export class DisableReason {
    code: string;
    name: string;
    sortOrder: number;
}


// WEBPACK FOOTER //
// ./src/app/models/disableReason.ts